// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3KmXo","image":"Header_image__1TBaM","name":"Header_name__3cueZ","info":"Header_info__3vA0B","infoRow":"Header_infoRow__1lGOI"};